import React, { ReactNode } from "react";

export interface AccordionItemProps {
  item: {
    id?: string;
    title: string;
    isOpen?: boolean;
    content?: ReactNode;
  };
  twoLevelParent?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}

export const AccordionItem = ({ item, twoLevelParent, onOpen, onClose }: AccordionItemProps) => {
  return (
    <div
      key={item.id ? `accordion-item-${item.id}` : undefined}
      data-id={item.id ? `accordion-item-${item.id}` : undefined}
      data-two-level-parent={twoLevelParent ? "true" : undefined}
      className={`accordion-item ${item.isOpen ? "is-open" : ""}`}
      data-close-icon={window.iconPlusMd}
      data-open-icon={window.iconMinusMd}
    >
      <div
        className="accordion-item-header px-4"
        onClick={(e) => {
          if (e.target.parentElement!.classList.contains("is-open")) {
            onOpen?.();
          } else {
            onClose?.();
          }
        }}
      >
        <div className="accordion-item-header-txt !text-base !font-normal">{item.title}</div>
        <div
          className="accordion-item-icon"
          dangerouslySetInnerHTML={{ __html: item.isOpen ? window.iconMinusMd : window.iconPlusMd }}
        />
      </div>
      <div className="accordion-item-content px-4">
        <div>{item.content}</div>
      </div>
    </div>
  );
};
